import {imageService} from "@/services/ImageService";
import {toast} from "vue3-toastify";
import {i18n} from "@/lang";

let imagesRequest = null;

const state = {
    images: [],
    imagesLoaded: false,
    isAddingImage: false,
    editingImage: false,
    editImageRequest : {
        loading: false
    },
    addImageRequest : {
        loading: false
    },
    getImageRequest : {
        loading: false
    },
    deleteImageRequest: {
        loading: false
    }
};

const mutations = {
    setImagesLoaded(state, loaded) {
        state.imagesLoaded = loaded;
    },
    invalidateImages(state) {
        state.imagesLoaded = false;
    },
    resetImages(state) {
        state.images = [];
        state.imagesLoaded = false;
    },
    SET_IMAGE(state, images) {
        state.images = [...images];
    },
    setEditingImage(state, editingImage){
        state.editingImage = editingImage;
        state.isAddingImage = false;
    },
    setGetImageRequest(state, {loading, message}){
        state.getImageRequest = {
            loading: loading,
            message: message
        }
    },
    setAddImageRequest(state, {loading, message}){
        state.addImageRequest = {
            loading: loading,
            message: message
        }
    },
    setEditImageRequest(state, {loading, message}){
        state.editImageRequest = {
            loading: loading,
            message: message
        }
    },
    setDeleteImageRequest(state, {loading, message}){
        state.deleteImageRequest = {
            loading: loading,
            message: message
        }
    },
    updateImage(state, newList){
        state.images = newList;
    },
    setIsAddingImage(state, isAddingImage){
        state.isAddingImage = isAddingImage;
        state.editingImage = null;
    }
};

const actions ={
    ensureImages({state, dispatch}){
        if (state.imagesLoaded) return Promise.resolve(state.images);
        if (!imagesRequest) {
            imagesRequest = dispatch('fetchImages').finally(() => {
                imagesRequest = null;
            });
        }
        return imagesRequest;
    },
    fetchImages({commit}){
        commit('setGetImageRequest', {loading: true})
        return imageService.getAllImages()
            .then((response) => {
                commit('setGetImageRequest', {loading: false})
                commit('updateImage', response.data);
                commit('setImagesLoaded', true);
            })
            .catch((error) => commit('setGetImageRequest', {loading: false, message: error}))
    },

    deleteImage({commit, state}, imageId){
        imageService.deleteImage(imageId)
            .then(() => {
                toast.success(i18n.global.t("toast.deleteSuccess"));
                const updatedImageList = state.images.filter(element => element.imageId !== imageId);
                commit('updateImage', updatedImageList);
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.deleteError"));
                commit("setDeleteImageRequest", {loading: false, message: error})
            })
    },

    async addImage({ commit, dispatch }, { orgId, extraAttachedFiles }) {
        commit('setAddImageRequest', {loading: true});

        const files = extraAttachedFiles || [];
        let successCount = 0;
        let failedCount = 0;

        for (const file of files) {
            try {
                await imageService.uploadImage(file, orgId, 0, 0, false);
                successCount++;
            } catch (error) {
                failedCount++;
            }
        }

        if (successCount > 0) {
            toast.success(i18n.global.t("imagePageStrings.addSuccess", {count: successCount}));
            dispatch('fetchImages');
        }

        if (failedCount > 0) {
            toast.error(i18n.global.t("imagePageStrings.addError", {count: failedCount}));
        }

        commit('setAddImageRequest', {loading: false});
        commit('setIsAddingImage', false);
    }
}

export const images = {
    namespaced: true,
    state,
    actions,
    mutations,
}
